(() => {
  const roots = document.querySelectorAll('[data-sp-shop]');
  roots.forEach((root) => {
    const buttons = [...root.querySelectorAll('[data-sp-filter]')];
    const cards = [...root.querySelectorAll('[data-sp-product]')];
    const empty = root.querySelector('[data-sp-filter-empty]');
    const terms = {
      panel: ['panel'],
      starter: ['starter', 'kit'],
      bundle: ['bundle'],
      accessor: ['accessor', 'controller', 'remote', 'power supply', 'cable']
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const filter = button.dataset.spFilter;
        let visible = 0;
        buttons.forEach((item) => {
          const active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
        });
        cards.forEach((card) => {
          const haystack = card.dataset.search || '';
          const show = filter === 'all' || terms[filter].some((term) => haystack.includes(term));
          card.hidden = !show;
          if (show) visible += 1;
        });
        if (empty) empty.hidden = visible !== 0;
      });
    });

    const sort = root.querySelector('[data-sp-sort]');
    sort?.addEventListener('change', () => sort.form?.submit());
  });
})();
